import GrayHeaderCard from "../../../../../components/ui/cards/gray-header-card/GrayHeaderCard";
import {Typography} from "@material-ui/core";
import DefaultSelect from "../../../../../components/ui/inputs/selects/default-select/DefaultSelect";
import React from "react";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import {useMainDialogContentStyles} from "./MainContentStyles";
import CurrentOffer from "./current-offer/CurrentOffer";
import NewOffer from "./new-offer/NewOffer";
import {Skeleton} from "@material-ui/lab";

const MainContent = (props) => {
    const classes = useMainDialogContentStyles();

    const getCardHeaderTitle = (
        <Typography variant={"subtitle2"}>
            Seleziona il nuovo piano
        </Typography>
    )

    return (
        <>
            <CurrentOffer currentOffer={props.currentOffer}/>

            <GrayHeaderCard title={getCardHeaderTitle}>
                <>
                    {!props.selectedPlan ? <Box className={classes.banner}>
                        <ErrorOutlineIcon fontSize={"medium"}
                                          className={classes.bannerIcon}
                                          color={"secondary"}/>
                        <Typography variant={"subtitle2"}
                                    className={classes.textBanner}
                                    display={"inline"}
                                    color={"textSecondary"}>
                            Verranno mostrati i piani con offerte compatibili per questa SIM
                        </Typography>
                    </Box> : null}

                    <Box marginTop={2}
                         marginBottom={1}>
                        {props.loading ?
                            <Skeleton animation={"wave"} width={"100%"}/>
                            :
                            <DefaultSelect
                                menuItems={props.menuItems}
                                handleOnChange={props.handleChangeSelectedPlan}
                                label={props.isFromDC ? "Cerca per nome piano" : "Piano"}
                                value={props.selectedPlan}
                                hasEmptyItem={true}
                                fullWidth={true}/>
                        }
                    </Box>
                </>
            </GrayHeaderCard>

            {props.selectedPlan ? <NewOffer isFromDC={props.isFromDC}/> : null}
        </>
    )
}

MainContent.propTypes = {
    currentOffer: PropTypes.object.isRequired,
    selectedPlan: PropTypes.string.isRequired,
    handleChangeSelectedPlan: PropTypes.func.isRequired,
    menuItems: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired
}

export default MainContent
